export default __webpack_public_path__ + "static/microsoft-sql-server-18f84630d77ee59a93814e1aa3bc9770.svg";